module.exports = __webpack_public_path__ + "static/media/shipbell.2a87c670.wav";